"use strict";
import React from "react";
import { Select, MenuItem, Grid } from "@mui/material";
import GlobalButton from "../Buttons/GlobalButton";

import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { secondaryColor, primaryColor } from "../../utils/constants";
import { useNavigate } from "react-router-dom";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    width: "0.1px",
    // height: "20px",
    borderRadius: "var(--radius-md)",
    position: "relative",
    // backgroundColor: "none",
    border: "none",
    fontSize: "var(--font-size-normal)",
    backgroundColor: `${primaryColor}`,
    padding: "0px 0px 5px 4px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    color: `${secondaryColor}`,
    fontFamily: "Livvic",
    // "&:focus": {
    //   borderRadius: 4,
    //   borderColor: "#80bdff",
    //   boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    // },
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  "& .MuiSelect-select": {
    backgroundColor: `${primaryColor} !important`,
    color: `${secondaryColor} !important`,
  },
  "& .MuiSelect-icon": {
    fontSize: "var(--font-size-normal)",
  },
}));

const StyledMenuItem = styled(MenuItem)({
    backgroundColor: "none !important",
    color: "none !important",
    "&.Mui-selected": {
        backgroundColor: "grey !important",
        color: "none !important",
    },
    "&:focus": {
        backgroundColor: "grey !important",
        color: `${primaryColor} !important`,
    },
});

const menuProps = {
    PaperProps: {
        style: {
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            maxHeight: "none",
            boxShadow: "none",
            borderRadius: "var(--radius-md)",
        },
    },
    disableScrollLock: false,
};

const dropdownMenuProps = {
    ...menuProps,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "right",
    },
};

const EmployeRolesNavBar = ({
  workTypes,
  projectFile,
  handleWork,
  getTaskNameFormal,
  getLanguageName,
}) => {
  const navigate = useNavigate();

    return (
        <StyledSelect input={<BootstrapInput />} MenuProps={menuProps}>
            {workTypes?.map((type, index) => (
                <StyledMenuItem key={index}>
                    <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Grid>{getTaskNameFormal(type)}</Grid>
                        <Grid>
                            {["translate", "performancedirection", "qualityassurance", "lipqualityassurance"].includes(type) ? (
                                <StyledSelect
                                    size="small"
                                    color="primary"
                                    defaultValue="Start Working"
                                    MenuProps={dropdownMenuProps}
                                >
                                    <StyledMenuItem value="Start Working">
                                        Start Working
                                    </StyledMenuItem>
                                    {projectFile?.finalLang?.map((language, langIndex) => (
                                        <StyledMenuItem
                                            key={langIndex}
                                            value={language}
                                            onClick={() => handleWork(projectFile, type, language)}
                                        >
                                            {getLanguageName(language)}
                                        </StyledMenuItem>
                                    ))}
                                </StyledSelect>
                            ) : (
                                <GlobalButton
                                    color="primary"
                                    onClick={() => handleWork(projectFile, type)}
                                >
                                    Start Working
                                </GlobalButton>
                            )}
                        </Grid>
                    </Grid>
                </StyledMenuItem>
            ))}
            <StyledMenuItem onClick={() => navigate(`/workpages/details/${projectFile.id}`)}>
                Analyze
            </StyledMenuItem>
            <StyledMenuItem onClick={() => navigate(`/projects/${projectFile.id}/voices`)}>
                Voices
            </StyledMenuItem>
        </StyledSelect>
    );
};

export default EmployeRolesNavBar;

